import { Tag } from '../api/Tag';
import { SupabaseService, supabase } from './SupabaseClient';

export class TagService extends SupabaseService {
    public async getTags(): Promise<Tag[]> {
        const { data, error } = await supabase.from('tags').select('*');
        this.throwIfQueryFailed(error);
        return this.normalizeTagList(data);
    }

    public async getUsedTags(): Promise<Tag[]> {
        const usedTagIds = await this.listUsedTagIds();

        if (usedTagIds.length === 0) {
            return [];
        }

        return this.fetchTagsByIds(usedTagIds);
    }

    public async addTag(tagName: string): Promise<Tag> {
        const supabaseClient = await this.getClient();
        const { data, error } = await supabaseClient.from('tags').insert([{ name: tagName }]).select().single();
        this.throwIfQueryFailed(error);
        return this.requireTag(data, 'Tag creation returned no data');
    }

    public async deleteTag(tagId: number): Promise<void> {
        const supabaseClient = await this.getClient();
        const { error } = await supabaseClient.from('tags').delete().eq('id', tagId);
        this.throwIfQueryFailed(error);
    }

    private async listUsedTagIds(): Promise<number[]> {
        const { data, error } = await supabase
            .from('recipe_tags')
            .select('tag_id');

        this.throwIfQueryFailed(error);

        return [...new Set((data || []).map(item => item.tag_id))];
    }

    private async fetchTagsByIds(tagIds: number[]): Promise<Tag[]> {
        const { data, error } = await supabase
            .from('tags')
            .select('*')
            .in('id', tagIds);

        this.throwIfQueryFailed(error);

        return this.normalizeTagList(data);
    }

    private normalizeTagList(data: Tag[] | null): Tag[] {
        return data || [];
    }

    private requireTag(data: Tag | null, errorMessage: string): Tag {
        if (!data) {
            throw new Error(errorMessage);
        }

        return data;
    }

    private throwIfQueryFailed(error: { message: string } | null): void {
        if (error) {
            throw new Error(error.message);
        }
    }
}

export const tagService = new TagService();
